import { AppDispatch } from '../../data/store';
import { WebSocketSessionInfo } from './webSocketService';
import { setReservationEventEmitted } from '../../data/reservation.slice';

export interface IReservationDetail {
  clientBC: string;
  correlationUUID: string;
  isInternal: boolean;
  modifiedByUserID: string;
  modifiedDateTimeUTC: string;
  passengerUUID: string;
  reservationReferenceID: string;
  reservationServiceDate: string;
  state: string;
}

enum ReservationEventType {
  ReservationActivated = 'ReservationActivated',
  ReservationDeactivated = 'ReservationDeactivated',
  ReservationDrafted = 'ReservationDrafted',
  ReservationCanceled = 'ReservationCanceled',
}

/**
 * Method for handling all Internal Note Events
 * @param sessionInfo The webSocketService sessionInfo object. Contains data copied over from the Redux store as needed
 * @param dispatch The Redux store dispatch function
 * @param detailType A string representing the type of event. Must be one of the TripLegEventType enum values
 * @param detail An object containing the event data, in this case a TripLeg
 */
function updateReservation(
  sessionInfo: WebSocketSessionInfo,
  dispatch: AppDispatch,
  detailType: string,
  detail: IReservationDetail,
) {
  switch (detailType) {
    case ReservationEventType.ReservationActivated:
    case ReservationEventType.ReservationDeactivated:
    case ReservationEventType.ReservationDrafted:
    case ReservationEventType.ReservationCanceled:
      dispatch(setReservationEventEmitted(detail));
      break;
  }
}

export { ReservationEventType, updateReservation };
